export default __webpack_public_path__ + "static/media/support.da04c186.svg";